import { render, staticRenderFns } from "./icon-cancel.vue?vue&type=template&id=49d2ab60"
import script from "./icon-cancel.vue?vue&type=script&lang=ts"
export * from "./icon-cancel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports